export default __webpack_public_path__ + "4507cfa80b61a087d6e9c1d8c9e4a049.jpg";